<template>
<div class="chap-editor" v-if="item.media">
  <h3>Chapters</h3>
  <a class="new-chapter" href="" v-on:click.prevent="add">+</a>
  <ul v-if="item.chapters">
    <li v-for="(chapter, ci) in item.chapters">
      <span>{{ formatTime(chapter.time) }}</span>
      <input type="text" v-model="chapter.title" />
      <a class="remove" v-if="chapter.time" href="" v-on:click.prevent="remove(ci)">&times;</a>
    </li>
  </ul>
</div>
</template>

<script>
export default {
  props: ["item"],
  methods: {
    formatTime(time) {
      var m=Math.floor(time/60);
      var s=Math.floor(time%60);
      return (m<10?'0':'')+m+":"+(s<10?'0':'')+s;
    },
    remove(index) {
      this.item.chapters.splice(index, 1);
    },
    add() {
      var now=Math.floor(this.$parent.playTime);
      var index=0;
      for(var i in this.item.chapters) {
        var chapter=this.item.chapters[i];
        if (chapter.time==now)
          return;
        if (chapter.time<=now)
          index=i;
      }
      this.item.chapters.splice(index+1, 0, {time: now, title: ""});
    },
  },
}
</script>
